import React from "react";
import Card from "components/card";
import {
    BookOpen,
} from "lucide-react";
import CoursesTabs from "./CoursesTabs";

const AssignedCoursesCard = ({ employee }) => {

    return (
        <Card className="flex flex-col gap-6 rounded-2xl border-2 shadow-sm bg-white">
            <div className="items-start gap-1.5 bg-slate-50/50 border-b rounded-t-xl px-6 pt-6 pb-6">
                <h4 className="text-[18px] flex items-center gap-2">
                    <BookOpen className="w-5 h-5 text-purple-600"/>
                    Assigned Courses & Milestones
                </h4>
                <p className="text-slate-500">
                    Track progress through structured learning paths
                </p>
            </div>
            <div className="p-6 pb-6">
               <CoursesTabs employee={employee} />
            </div>
        </Card>
    );
};

export default AssignedCoursesCard;